import { render, staticRenderFns } from "./import-from-proposal.vue?vue&type=template&id=d3d186ba&scoped=true"
import script from "./import-from-proposal.vue?vue&type=script&lang=js"
export * from "./import-from-proposal.vue?vue&type=script&lang=js"
import style0 from "./import-from-proposal.vue?vue&type=style&index=0&id=d3d186ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d186ba",
  null
  
)

export default component.exports